import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import GenericDialog from '../components/GenericDialog';
import ContentBox from '../components/layout/ContentBox';
import Review from '../components/review/Review';

import {
  surveyShape,
  surveySubmissionShape,
  reviewSubmissionShape,
} from '../types';

export default class ReviewDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 0,
    };
  }

  render() {
    const {
      review,
      reviewRequest,
      survey,
      evaluation,
      submission,
      isOpen,
      onClose,
    } = this.props;
    const { currentTab } = this.state;
    const { reviewSurvey } = reviewRequest || {};
    return (
      <GenericDialog
        isOpen={isOpen}
        onClose={onClose}
        closeButtonLabel={<FormattedMessage id="genericClose" />}
      >
        <div id="ReviewContent">
          <ContentBox
            title={
              <FormattedMessage id="reviewdialog.headline" />
            }
          >
            <Review
              surveyIdsMatchReviewSurvey={!reviewSurvey}
              survey={survey.payload}
              reviewSurvey={reviewSurvey}
              reviewSubmission={review}
              currentSection={currentTab}
              onCurrentSectionChange={(idx) => this.setState({ currentTab: idx })}
              evaluation={evaluation}
              submission={submission}
              readOnly
            />
          </ContentBox>
        </div>
      </GenericDialog>
    );
  }
}

ReviewDialog.defaultProps = {
  reviewRequest: undefined,
};

ReviewDialog.propTypes = {
  review: reviewSubmissionShape.isRequired,
  reviewRequest: surveyShape,
  evaluation: PropTypes.shape({}).isRequired, // as in Certificate model
  submission: surveySubmissionShape.isRequired,
  survey: surveyShape.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
